var _style, _polyline, _path, _line, _line2, _line3, _line4, _line5, _line6, _polyline2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewtask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76.9 90.7",
    style: {
      enableBackground: "new 0 0 76.9 90.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.newtask0{fill:none;stroke:#3949ab;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.newtask01{fill:none;stroke:#D99A29;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "newtask0",
    points: "13,89.7 75.9,89.7 75.9,1 29.7,1 13,18.3 13,53.4 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "newtask0",
    d: "M30.1,1v10.1c0,4.2-3.4,7.6-7.6,7.6H13"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "newtask0",
    x1: 68.4,
    y1: 12.9,
    x2: 39.7,
    y2: 12.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "newtask0",
    x1: 68.4,
    y1: 26,
    x2: 39.7,
    y2: 26
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "newtask0",
    x1: 68.4,
    y1: 39.1,
    x2: 21.6,
    y2: 39.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "newtask0",
    x1: 68.4,
    y1: 52.3,
    x2: 26.3,
    y2: 52.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "newtask0",
    x1: 68.4,
    y1: 65.4,
    x2: 37.8,
    y2: 65.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "newtask0",
    x1: 68.4,
    y1: 78.5,
    x2: 37.8,
    y2: 78.5
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "newtask01",
    points: "7.1,69 15.4,76.4 33.2,59.8 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "newtask01",
    cx: 14.8,
    cy: 71.2,
    r: 13.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewtask);
export default __webpack_public_path__ + "static/media/newtask.2b3681e810707683985351837befefac.svg";
export { ForwardRef as ReactComponent };